export default [
	{
		id: 1,
		page: '1',
		articles: []
	},
	{
		id: 2,
		page: '2 & 3',
		articles: []
	},
	{
		id: 3,
		page: '4',
		articles: []
	},
	{
		id: 4,
		page: 'Extended Reading',
		articles: []
	}
]
